var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import debounce from "lodash/debounce";
import { fetchAddressSuggestions } from "./publisherRegistrationApi";
/** Pause after the last keystroke before the address suggest endpoint is asked (DB-876). */
export var ADDRESS_SUGGEST_DEBOUNCE_MS = 300;
/**
 * Typeahead state of an address picker on the public registration form: debounced, at least
 * three characters, stale answers dropped, "nothing found" as an empty list and a rate limit
 * reported through {@code rateLimited} instead of an error.
 */
export var useAddressSuggest = function (ky) {
    var _a = useState([]), addresses = _a[0], setAddresses = _a[1];
    var _b = useState(false), rateLimited = _b[0], setRateLimited = _b[1];
    var latestRequest = useRef(0);
    // useOkapiKy() returns a new client on every render; a stable search keeps the debounce alive.
    var kyRef = useRef(ky);
    kyRef.current = ky;
    var search = useCallback(function (query) { return __awaiter(void 0, void 0, void 0, function () {
        var requestId, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    latestRequest.current += 1;
                    requestId = latestRequest.current;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetchAddressSuggestions(kyRef.current, query)];
                case 2:
                    result = _a.sent();
                    if (requestId === latestRequest.current) {
                        setAddresses(result.addresses);
                        setRateLimited(result.rateLimited);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    if (requestId === latestRequest.current) {
                        // eslint-disable-next-line no-console
                        console.error("Error fetching addresses:", error_1);
                        setAddresses([]);
                        setRateLimited(false);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, []);
    var onFilter = useMemo(function () { return debounce(search, ADDRESS_SUGGEST_DEBOUNCE_MS); }, [search]);
    useEffect(function () { return function () { return onFilter.cancel(); }; }, [onFilter]);
    return { addresses: addresses, rateLimited: rateLimited, onFilter: onFilter };
};
